module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('data-table', {
    attrs: {
      "table-ref": "progress-table",
      "title": _vm.permitLabel,
      "icon": "fa fa-share-alt",
      "hide-org-badge": _vm.hideBadge,
      "show-search": _vm.showSearch,
      "url": '/actions/site/' + _vm.rowData.id + '/null/prg',
      "fields": _vm.fields,
      "detail-component": "progress-detail-row"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ead12a80"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sites/SiteProgress.vue
// module id = 1733
// module chunks = 0